import { render, staticRenderFns } from "./Sextants.vue?vue&type=template&id=784ebe62&"
import script from "./Sextants.vue?vue&type=script&lang=js&"
export * from "./Sextants.vue?vue&type=script&lang=js&"
import style0 from "./Sextants.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports